import React from 'react'
import QRCode from 'react-qr-code'
import useViewModel from './ViewModel'
import './styles.css'
const PrintView: React.FC = () => {
  const { data } = useViewModel()

  return (
    <div style={{ height: 'auto',   }}>
      <div className=''>
        {data.map((qrcode, index) => (
          <div className={`text-center ${index !== data.length - 1 ? 'page-break' : ''}`} key={index}>
            <QRCode
              size={256}
              className='qr-image'
              // style={{ height: 'auto', maxWidth: '100%', width: '100%', marginTop: '20px' }}
              value={qrcode.inventoryCode}
              viewBox={`0 0 256 256`}
            />
            <div className='qr-text fw-bold mt-5 text-center'>
              <div>{qrcode.itemCode} | {qrcode.factory} |</div>
              <div>{qrcode.inventoryCode}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PrintView
